import { config as appConfig } from "@/config";

import Vue from "vue";
import axios from "axios";
import { ParseResultType, parseDomain } from "parse-domain";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
const AUTH_TOKEN = localStorage.getItem("token");
if (AUTH_TOKEN && process.env.NODE_ENV == "development") {
  axios.defaults.headers.common["Authorization"] = `Bearer ${AUTH_TOKEN}`;
}
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// Runtime config (window.APP_CONFIG.BASE_URL injected by
// docker-entrypoint.sh at container start) is the source of truth when
// set. The hostname-derived fallback below is kept for multi-tenant
// production deploys where BASE_URL is not injected. It must NOT run
// when BASE_URL is explicitly set — otherwise staging-* subdomains get
// silently routed to the production `services.<domain>.<tld>` host.
let serviceUrl = appConfig.BASE_URL || process.env.apiUrl || "";
if (!appConfig.BASE_URL && process.env.NODE_ENV != "development") {
  const parseResult = parseDomain(window.location.hostname);

  if (parseResult.type === ParseResultType.Listed) {
    const { domain, topLevelDomains } = parseResult;
    const topLevel = topLevelDomains.join(".");
    serviceUrl = `https://services.${domain}.${topLevel}`;
  }
}

// Setting up the custom flag in the headers
// You can modify this part to suit your flag's name and value
const CUSTOM_HEADER_NAME = "X-Cookie-Staff"; // Example header name
const CUSTOM_HEADER_VALUE = "true"; // Example value, determine how you set this based on your app's logic

const config = {
  baseURL: serviceUrl,
  timeout: 60 * 1000, // Timeout
  withCredentials: true, // allow credentials to be send, including cookies in the request header
  crossorigin: true,
};

const _axios = axios.create(config);

// Adding the custom header to all requests
_axios.interceptors.request.use(
  function (config) {
    config.headers.common[CUSTOM_HEADER_NAME] = CUSTOM_HEADER_VALUE;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const AxiosPlugin = {} as any;

AxiosPlugin.install = function (Vue: any) {
  Vue.axios = _axios;
  (window as any).axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });
};

Vue.use(AxiosPlugin);

export default AxiosPlugin;
